import React from 'react';
import cx from 'classnames';

import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { ColorPalette } from 'types/constants';

import style from './style.module.scss';

interface Props {
  children: any;
  colorPalette: ColorPalette;
  disabled?: boolean;
  href?: string;
  icon: React.ReactNode;
  onClick?: () => void;
  submitting?: boolean;
}

export default (props: Props) => {
  return (
    <a
      className={cx(
        style.button,
        'align-items-center d-flex gap-xs justify-content-center',
        { [style.disabled]: !!props.disabled }
      )}
      href={props.disabled ? null : props.href}
      onClick={props.disabled ? null : props.onClick}
      style={{
        boxShadow: `0px 0px 8px ${props.colorPalette.dark}, 0px 0px 0px 1px rgba(0, 0, 0, 0.1)`,
        cursor: props.disabled ? 'default' : 'pointer',
        pointerEvents: props.disabled ? 'none' : 'auto'
      }}
    >
      <div className="align-items-center d-flex justify-content-center" style={{ height: 24, width: 24 }}>
        {
          props.submitting ? (
            <div>
              <FontAwesomeIcon
                className="fa-pulse"
                icon="spinner"
                style={{ color: props.colorPalette.dark }}
              />
            </div>
          ) : props.icon
        }
      </div>

      <div>
        <small><strong>{props.children}</strong></small>
      </div>
    </a>
  );
};
